import { selectFromVisitDto } from '../../models';

const VisitLatLngQuery = selectFromVisitDto()
  .id
  .uuid
  .eventUuid
  .projectId
  .isCompleted
  .isScheduled
  .isUnscheduling
  .deliveryDate
  .locations(b => b
    .latitude
    .longitude
    .locationStatusId
    .active
    .bestMatch)
  .toString();

export default VisitLatLngQuery;
